export enum MemeAction {
  MemesLoaded,
  MemeDeleted,
  MemeAdded,
  MemeVoted
}
